<div class="flex gap-3">
  <button
    (click)="setRate(i + 1)"
    *ngFor="let active of rateArray; let i = index; trackBy: trackByFn"
    [ngClass]="active ? 'bg-apricot-2' : 'bg-grey-8'"
    class="inline-flex h-10 w-10 items-center justify-center rounded-full border-none transition-all"
    type="button"
  >
    <app-ui-icon color="var(--white)" name="star_filled"></app-ui-icon>
  </button>
</div>
